import React from 'react';
import { bindActionCreators } from 'redux';
import * as adminActionCreator from '../../actions/admin';
import * as commonActionCreator from '../../actions/common';
import { connect } from 'react-redux';
import { Panel, Button } from 'react-bootstrap';
import moment from 'moment';

class CCDA extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasCheckedCCDA: false,
            hasCheckedMedSummary: false,
            hasCheckedHealthSummary: false,
            hasCheckedQualitySummary: false,
        };
    }

    componentDidMount() {
        if (!this.props.selectedPatient) {
            this.showErrorMessage(
                'Unknown Patient',
                'Patient Details aren\'t Available. Please Refresh the Page or Try Again Later.',
            );
            this.setState({
                hasCheckedCCDA: true,
                hasCheckedMedSummary: true,
                hasCheckedHealthSummary: true,
                hasCheckedQualitySummary: false,
            });
        } else {
            this.checkMedSummaryAvailability();
            this.checkCCDAAvailability();
            this.checkHealthSummaryAvailability();
            this.checkQualitySummaryAvailability();
        }
    }

    checkMedSummaryAvailability = () =>
        this.props.adminActions.getMedSummaryAvailability(this.props.selectedPatient.id)
            .then(() => {
                this.setState({ hasCheckedMedSummary: true });
            });

    checkCCDAAvailability = () =>
        this.props.adminActions.getCCDAAvailability(this.props.selectedPatient.id)
            .then(() => {
                this.setState({ hasCheckedCCDA: true });
            });

    checkHealthSummaryAvailability = () =>
        this.props.adminActions.getHealthSummaryAvailability(this.props.selectedPatient.id)
            .then(() => {
                this.setState({ hasCheckedHealthSummary: true });
            });

    checkQualitySummaryAvailability = () =>
        this.props.adminActions.getQualitySummaryAvailability(this.props.selectedPatient.id)
            .then(() => {
                this.setState({ hasCheckedQualitySummary: true });
            });

    showErrorMessage = (title, message) => {
        this.props.commonActions.showToast({
            status: 'error',
            title: title,
            message: message
        });
        var interval = setInterval(()=> {
            clearInterval(interval);
            this.props.commonActions.hideToast();
        }, 2);
    }

    showCCDA = () => {
        const selectedPatient = this.props.selectedPatient;

        if (!selectedPatient) {
            this.showErrorMessage(
                'Unknown Patient',
                'Patient Details aren\'t Available. Please Refresh the Page or Try Again Later.',
            );
        } else {
            this.props.adminActions.getCCDAPdf(selectedPatient.id)
                .then(() => {
                    window.open(this.props.ccdaPdfUrl, '_blank').focus();
                })
                .catch(() => false);
        }
    }

    showMedicalSummary = () => {
        const selectedPatient = this.props.selectedPatient;

        if (!selectedPatient) {
            this.showErrorMessage(
                'Unknown Patient',
                'Patient Details aren\'t Available. Please Refresh the Page or Try Again Later.',
            );
        } else {
            this.props.adminActions.getMedSummaryPdf(selectedPatient.id)
                .then(() => {
                    window.open(this.props.medSummaryPdfUrl, '_blank').focus();
                })
                .catch(() => false);
        }
    }

    showHealthSummary = () => {
        const selectedPatient = this.props.selectedPatient;

        if (!selectedPatient) {
            this.showErrorMessage(
                'Unknown Patient',
                'Patient Details aren\'t Available. Please Refresh the Page or Try Again Later.',
            );
        } else {
            this.props.adminActions.getHealthSummaryPdf(selectedPatient.id)
                .then(() => {
                    window.open(this.props.healthSummaryPdfUrl, '_blank').focus();
                })
                .catch(() => false);
        }
    }

    showQualitySummary = () => {
        const selectedPatient = this.props.selectedPatient;

        if (!selectedPatient) {
            this.showErrorMessage(
                'Unknown Patient',
                'Patient Details aren\'t Available. Please Refresh the Page or Try Again Later.',
            );
        } else {
            this.props.adminActions.getQualitySummaryPdf(selectedPatient.id)
                .then(() => {
                    window.open(this.props.qualitySummaryPdfUrl, '_blank').focus();
                })
                .catch(() => false);
        }
    }

    render() {
        const { hasCheckedCCDA, hasCheckedMedSummary, hasCheckedHealthSummary, hasCheckedQualitySummary } = this.state;
        const { ccdaAvailable, medSummaryAvailable, healthSummaryAvailable, qualitySummaryAvailable, selectedPatient } = this.props;

        return (
            <Panel>
                <div style={{ textAlign: 'center', marginBottom: '1rem' }}>
                    {!hasCheckedCCDA &&
                        <div><i>Checking for CCDA availability...</i></div>
                    }
                    {hasCheckedCCDA && !ccdaAvailable &&
                        <div>CCDA is unavailable for the patient.</div>
                    }
                    {hasCheckedCCDA && ccdaAvailable &&
                        <div>
                            <Button bsStyle="success" onClick={this.showCCDA}>
                                CCDA
                            </Button>
                            <span style={{paddingLeft:25}}>
                                {selectedPatient.ccda_ts ? moment.utc(selectedPatient.ccda_ts).local().format('MM/DD/YYYY HH:mm')
                                : ' - '}
                            </span>
                        </div>
                    }
                </div>
                <div style={{ textAlign: 'center', marginBottom: '1rem' }}>
                    {!hasCheckedMedSummary &&
                        <div><i>Checking for medical summary availability...</i></div>
                    }
                    {hasCheckedMedSummary && !medSummaryAvailable &&
                        <div>Medical summary is unavailable for the patient.</div>
                    }
                    {hasCheckedMedSummary && medSummaryAvailable &&
                        <div>
                            <Button bsStyle="success" onClick={this.showMedicalSummary}>
                                Medical Summary
                            </Button>
                            <span style={{paddingLeft:25}}>
                                {selectedPatient.medsummary_ts ? moment.utc(selectedPatient.medsummary_ts).local().format('MM/DD/YYYY HH:mm')
                                : ' - '}
                            </span>
                        </div>
                    }
                </div>
                <div style={{ textAlign: 'center', marginBottom: '1rem' }}>
                    {!hasCheckedHealthSummary &&
                        <div><i>Checking for health summary availability...</i></div>
                    }
                    {hasCheckedHealthSummary && !healthSummaryAvailable &&
                        <div>Health summary is unavailable for the patient.</div>
                    }
                    {hasCheckedHealthSummary && healthSummaryAvailable &&
                        <div>
                            <Button bsStyle="success" onClick={this.showHealthSummary}>
                                Health Summary
                            </Button>
                        </div>
                    }
                </div>
                <div style={{ textAlign: 'center' }}>
                    {!hasCheckedQualitySummary &&
                        <div><i>Checking for quality summary availability...</i></div>
                    }
                    {hasCheckedQualitySummary && !qualitySummaryAvailable &&
                        <div>Quality summary is unavailable for the patient.</div>
                    }
                    {hasCheckedQualitySummary && qualitySummaryAvailable &&
                        <div>
                            <Button bsStyle="success" onClick={this.showQualitySummary}>
                                Quality Summary
                            </Button>
                        </div>
                    }
                </div>
            </Panel>
        );
    }
}

const mapStateToProps = (state) => ({
    ccdaAvailable: state.levelTwoDashboard.ccdaAvailable,
    ccdaPdfUrl: state.levelTwoDashboard.ccdaPdfUrl,
    medSummaryAvailable: state.levelTwoDashboard.medSummaryAvailable,
    medSummaryPdfUrl: state.levelTwoDashboard.medSummaryPdfUrl,
    healthSummaryAvailable: state.levelTwoDashboard.healthSummaryAvailable,
    healthSummaryPdfUrl: state.levelTwoDashboard.healthSummaryPdfUrl,
    qualitySummaryAvailable: state.levelTwoDashboard.qualitySummaryAvailable,
    qualitySummaryPdfUrl: state.levelTwoDashboard.qualitySummaryPdfUrl,
    selectedPatient: state.app.selectedPatient,
});

const mapDispatchToProps = (dispatch) => ({
    adminActions: bindActionCreators(adminActionCreator, dispatch),
    commonActions: bindActionCreators(commonActionCreator, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CCDA);
